import Component from '@averyano/core/src/classes/Component';
import GSAP from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { lerp } from '../../utils/utils';

GSAP.registerPlugin(ScrollTrigger);

export default class AboutSection extends Component {
	constructor() {
		super({
			element: '.about',
			elements: {
				eyeLeft: '#eye-left',
				eyeRight: '#eye-right',
			},
		});

		this.inView = false;
		this.playback = false;

		this.x = 0;
		this.y = 0;
		this.targetX = 0;
		this.targetY = 0;

		this.maximumX = 80;
		this.maximumY = 16;
		this.smoothness = 0.2;

		this.xMultiplier = 0;
		this.interactiveHeight = 0;

		this.onMouseMoveBound = this.onMouseMove.bind(this);
	}

	create() {
		super.createComponent();
		this.eyes = [this.elements.eyeLeft, this.elements.eyeRight];
		this.isMobile = window.matchMedia('(max-width: 767px)');
		this.onResize();
		this.createScrollTrigger();
		this.addEventListeners();
	}

	createScrollTrigger() {
		this.scrollTrigger = ScrollTrigger.create({
			trigger: this.element,
			start: 'top bottom',
			end: 'bottom top',
			onToggle: (self) => {
				this.x = 0;
				this.y = 0;
				const t = `translateX(${this.x}px) translateY(${this.y}px)`;
				this.elements.eyeLeft.style.transform = t;
				this.elements.eyeRight.style.transform = t;
				this.inView = self.isActive;
			},
			onUpdate: (self) => {
				if (!this.isMobile.matches) return;
				this.targetY = -this.maximumY + self.progress * 2 * this.maximumY;
				this.targetX = 0;
			},
		});
	}

	addEventListeners() {
		if (!this.isMobile.matches) {
			window.addEventListener('mousemove', this.onMouseMoveBound);
		}
	}

	removeEventListeners() {
		window.removeEventListener('mousemove', this.onMouseMoveBound);
	}

	onMouseMove(e) {
		this.targetX = e.clientX * this.xMultiplier - this.maximumX;
		if (e.clientY > this.interactiveHeight) {
			this.targetY = this.maximumY;
		} else {
			this.targetY =
				(e.clientY / this.interactiveHeight) * 2 * this.maximumY -
				this.maximumY;
		}
	}

	update() {
		if (!this.inView) return;
		if (this.playback) return;
		this.x = lerp(this.x, this.targetX, this.smoothness);
		this.y = lerp(this.y, this.targetY, this.smoothness);
		const t = `translateX(${this.x}px) translateY(${this.y}px)`;
		this.elements.eyeLeft.style.transform = t;
		this.elements.eyeRight.style.transform = t;
	}

	onResize() {
		this.xMultiplier = (2 * this.maximumX) / window.innerWidth;
		this.interactiveHeight = 2 * window.innerHeight;
	}

	destroy() {
		this.scrollTrigger?.kill();
		this.removeEventListeners();
	}
}
